import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from './values';
const CardRowContainer = ({ children }) => <View style={styles.container}>{children}</View>;
export default React.memo(CardRowContainer);
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(4),
    },
});
